<template>
  <div>
    <v-row>
      <v-flex sm4 xs12></v-flex>
      <v-flex sm8 xs12>
        <v-sapcer></v-sapcer>
        <v-text-field
          class="ml-16 mr-8"
          label="Search"
          append-icon="mdi-magnify"
          v-model="searchItem"
        ></v-text-field>
      </v-flex>
    </v-row>
    <v-data-table
      loading-text="Fetching Data"
      :search="searchItem"
      :headers="tableHeader"
      :items="tableRows"
      :items-per-page="10"
      class="elevation-1 mx-4"
    >
      <template v-slot:item.selection="{ item }">
        <v-checkbox
          class="shrink"
          :value="item.id"
          v-model="selectedTableItems"
        ></v-checkbox>
        <v-icon @click="editTableItem(item)" v-if="isAdmin">mdi-pencil</v-icon>
        <v-btn
          v-if="selectedTable == 'live_lessons' || selectedTable == 'subjects'"
          color="green accent-4"
          class="mx-1"
          rounded
          x-small
          dark
          @click="joinLiveLesson(item)"
          >Join Now</v-btn
        >
      </template>
      <template v-slot:item.id="{ item }">
        <v-btn
          v-for="(rtable, rind) in relatedTables"
          :key="rind + Math.random() + Math.random()"
          :color="btnColors[rind]"
          class="mx-1"
          rounded
          x-small
          dark
          @click="showRelTable(rtable, item)"
          >{{ rtable }}</v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: [
    "tableHeader",
    "tableRows",
    "selectedTable",
    "selectedTableItemsArray",
  ],
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  watch: {
    selectedTableItemsArray(newVal) {
      this.selectedTableItems = newVal;
    },
    selectedTableItems(newVal) {
      this.getSelections();
    },
  },
  data: () => ({
    searchItem: null,
    selectedTableItems: [],
    relatedTables: [],
    btnColors: [
      "#3dc7be",
      "indigo darken-4",
      "amber darken-4",
      "blue-grey darken-4",
      "orange accent-4",
      "yellow accent-4",
      "light-green accent-4",
      "pink darken-3",
    ],
  }),
  methods: {
    getSelections() {
      this.$emit("table-item-selected", this.selectedTableItems);
    },
    editTableItem(item) {
      this.$emit("edit-item", item);
    },
  },
};
</script>

<style></style>
